import List from './List';
import Create from './Create';
import Edit from './Edit';

export const Organisation = {
  List,
  Create,
  Edit,
};
